import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    BooleanField,
    NumberField,
} from 'react-admin'


export const CategoriaVUShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="description" />
            <NumberField source="vida_util" />
            <BooleanField source="active" />
        </SimpleShowLayout>
    </Show>
);
